'use client';

import { ErrorWrapper } from '@frodo/ui/tokens';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return <ErrorWrapper error={error} />;
}
